import { HEX_253548, HEX_E2E8F0 } from '@tanium/colors';
import {
  defineColor,
  InputActiveBorder,
  InputActiveFill,
  InputBorder,
  InputDisabledBorder,
  InputDisabledFill,
  InputFill,
  InputFocus,
  InputHoverBorder,
  InputInvalidBorder,
  InputSelectedFill,
  Text1,
} from '@tanium/react-theme-definition';

export const Label = Text1;

export const Fill = InputFill;
export const Border = InputBorder;

export const SelectedFill = InputSelectedFill;

export const HoverBorder = InputHoverBorder;

export const ActiveBorder = InputActiveBorder;
export const ActiveFill = InputActiveFill;

export const DisabledFill = InputDisabledFill;
export const DisabledBorder = InputDisabledBorder;
export const DisabledSelectedFill = defineColor([HEX_E2E8F0, HEX_253548]);
export const DisabledDotFill = InputDisabledBorder;

export const InvalidBorder = InputInvalidBorder;

export const FocusShadow = InputFocus;
